import { memo } from "react";

import { Image } from "@react/components/Image";
import { Link } from "@react/components/Link";
import { Text } from "@react/components/Text";
import { getFullyQualifiedUrl } from "@root/tablescape/utilities";
import { tw } from "classnames";

export interface Props {
  imageSrc: string;
  name: string;
  url: string;
}

const FeaturedItemBase = ({ imageSrc, name, url }: Props) => {
  return (
    <Link
      className={tw(
        "px-4",
        "py-2",
        "border",
        "border-solid",
        "border-primary",
        "rounded-lg",
        "flex",
        "items-center",
        "gap-x-4",
        "no-underline"
      )}
      mtrAs="clickCartModule"
      to={String(getFullyQualifiedUrl(url))}
      unstyled
    >
      <Image
        height={48}
        src={String(getFullyQualifiedUrl(imageSrc))}
        width={48}
      />
      <Text as="body2" className={tw("text-primary")}>
        {name}
      </Text>
    </Link>
  );
};

export const FeaturedItem = memo(FeaturedItemBase);
